import {
  MapboxFeature,
  MapClickGetPois,
  Poi,
  PowerOutageFeatureProperties,
  PowerOutagePoi,
} from 'features/mapping/mapping.types';
import { safeParseDate } from 'shared/dates';

const getPowerOutageMetadata = (
  feature: MapboxFeature<PowerOutageFeatureProperties>,
): PowerOutagePoi => ({
  utilityName: feature.properties.utility_name,
  customersAffected: feature.properties.customers_affected,
  cause: feature.properties.outage_cause,
  dateRecorded: safeParseDate(feature.properties.date_recorded),
  estimatedRestorationTime: safeParseDate(
    feature.properties.estimated_restoration_time,
  ),
});

export const getSelectedPowerOutageId = (selectedPoi?: Poi): string => {
  return selectedPoi?.type === 'powerOutage' && selectedPoi.id
    ? String(selectedPoi.id)
    : '';
};

export const powerOutageClickHandler: MapClickGetPois<
  PowerOutageFeatureProperties
> = (geoJsonFeatures) => {
  const feature = geoJsonFeatures[0];
  return [
    {
      type: 'powerOutage',
      id: feature.id,
      metadata: getPowerOutageMetadata(feature),
    },
  ];
};
